import { createListFromObject } from "../../../../../utils/UniversalFunction";

export const styles = {
    modalHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px 20px',
        background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)',
        borderBottom: '1px solid #e5e7eb'
    },
    modalHeaderTitle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        margin: 0
    },
    modalHeaderActions: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center'
    },
    iconButton: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        background: 'white',
        border: '1px solid #e5e7eb',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s'
    },
    mainContainer: {
        backgroundColor: '#f8f9fa',
        display: 'flex',
        flexDirection: 'row',
        overflow: 'hidden',
        height: '75vh'
    },
    contentArea: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'all 0.3s ease'
    },
    sidebar: {
        width: '30%',
        backgroundColor: 'white',
        borderLeft: '1px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s ease',
        boxShadow: '-2px 0 8px rgba(0,0,0,0.05)'
    },
    sidebarHeader: {
        padding: '16px 20px',
        borderBottom: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#fafafa'
    },
    sidebarTitle: {
        fontSize: '16px',
        fontWeight: '600',
        color: '#1f2937',
        margin: 0
    },
    sidebarContent: {
        flex: 1,
        overflowY: 'auto',
        padding: '20px'
    },
    chatContainer: {
        flex: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 0'
    },
    messagesArea: {
        flex: 1,
        overflowY: 'auto',
        padding: '0'
    },
    chartContainer: {
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '20px',
        border: '1px solid #e5e7eb',
        width: '100%',
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
    },
    chartHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #f3f4f6'
    },
    chartTitle: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#1f2937',
        margin: 0
    },
    chartDescription: {
        fontSize: '13px',
        color: '#6b7280',
        margin: '4px 0 0 0'
    },
    actionButton: {
        backgroundColor: '#f3f4f6',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        padding: '8px 12px',
        fontSize: '13px',
        fontWeight: 500,
        color: '#374151',
        cursor: 'pointer',
        transition: 'all 0.2s',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    },
    createButton: {
        backgroundColor: '#3f88a5',
        color: 'white',
        border: 'none',
        padding: '10px 20px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 500,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        transition: 'all 0.2s'
    },
    emptyState: {
        textAlign: 'center',
        padding: '60px 20px',
        color: '#6b7280'
    },
    emptyStateIcon: {
        fontSize: '48px',
        marginBottom: '16px'
    },
    emptyStateTitle: {
        fontSize: '20px',
        fontWeight: 600,
        color: '#374151',
        marginBottom: '8px'
    },
    emptyStateText: {
        fontSize: '15px',
        color: '#6b7280',
        marginBottom: '20px'
    },
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px',
        gap: '16px'
    },
    spinner: {
        width: '40px',
        height: '40px',
        border: '3px solid #e5e7eb',
        borderTop: '3px solid #3f88a5',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
    },
    errorContainer: {
        padding: '12px 16px',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '12px',
        color: '#991b1b',
        fontSize: '14px',
        margin: '16px 0',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    formGroup: {
        marginBottom: '16px'
    },
    formLabel: {
        fontSize: '14px',
        fontWeight: 500,
        color: '#374151',
        marginBottom: '6px',
        display: 'block'
    },
    formInput: {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        boxSizing: 'border-box'
    },
    formTextarea: {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        minHeight: '80px',
        resize: 'vertical',
        fontFamily: 'inherit',
        boxSizing: 'border-box'
    },
    buttonGroup: {
        display: 'flex',
        gap: '12px',
        justifyContent: 'flex-end',
        marginTop: '20px',
        paddingTop: '20px',
        borderTop: '1px solid #e5e7eb'
    },
    cancelButton: {
        padding: '10px 20px',
        backgroundColor: '#f3f4f6',
        border: '1px solid #e5e7eb',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 500,
        color: '#374151',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    submitButton: {
        padding: '10px 20px',
        backgroundColor: '#3f88a5',
        border: 'none',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: '500',
        color: 'white',
        cursor: 'pointer',
        transition: 'all 0.2s'
    },
    sectionHeader: {
        fontSize: '15px',
        fontWeight: 600,
        color: '#1f2937',
        marginTop: '24px',
        marginBottom: '12px',
        paddingBottom: '8px',
        borderBottom: '2px solid #e5e7eb'
    },
    checkboxGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: '8px'
    },
    checkbox: {
        width: '18px',
        height: '18px',
        cursor: 'pointer'
    },
    checkboxLabel: {
        fontSize: '14px',
        color: '#374151',
        cursor: 'pointer',
        userSelect: 'none'
    },
    infoText: {
        fontSize: '12px',
        color: '#6b7280',
        marginTop: '4px',
        fontStyle: 'italic'
    },
    formInputError: {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #dc2626',
        borderRadius: '8px',
        fontSize: '14px',
        outline: 'none',
        boxSizing: 'border-box'
    },
    errorMessage: {
        color: '#dc2626',
        fontSize: '12px',
        marginTop: '4px',
        display: 'block',
        fontWeight: '500'
    },
    requiredIndicator: {
        color: '#dc2626',
        marginLeft: '2px'
    },

    container: { minHeight: '100vh', padding: '40px 20px', },
    contentWrapper: { maxWidth: '1400px', margin: '0 auto' },

    // SUMMARY GRID STYLES
    summaryGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
        gap: '20px',
        marginBottom: '40px',
        alignItems: 'stretch'
    },
    summaryCard: {
        background: 'white',
        borderRadius: '14px',
        padding: '18px 20px',
        boxShadow: '0 4px 14px rgba(0,0,0,0.06)',
        border: '1px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '110px',
        position: 'relative',
        // width: '100%' <--- Remove this if it exists
    },
    summaryValue: {
        fontSize: '30px',
        fontWeight: '700',
        color: '#111827',
        lineHeight: 1.1
    },
    summaryLabel: {
        fontSize: '14px',
        color: '#6b7280',
        fontWeight: '500',
        marginTop: '4px'
    },

    summaryActions: { position: 'absolute', top: '10px', right: '10px', display: 'flex', gap: '5px' },

    // GRAPH STYLES
    graphsGrid: { display: 'flex', flexDirection: 'column', gap: '30px' },
    graphCard: {
        background: 'white',
        borderRadius: '20px',
        padding: '32px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.05)',
        position: 'relative',
        border: '1px solid #edf2f7'
    },
    dragHandle: { position: 'absolute', top: '35px', left: '20px', cursor: 'grab', color: '#cbd5e0' },
    graphHeader: { paddingLeft: '30px', marginBottom: '24px', borderBottom: '1px solid #edf2f7', paddingBottom: '15px' },
    graphTitle: { fontSize: '20px', fontWeight: '600', color: '#2d3748' },
    // MODAL & BUTTONS
    saveButtonContainer: { position: 'fixed', bottom: '30px', right: '30px', display: 'flex', gap: '12px', zIndex: 1000 },
    saveButton: { padding: '12px 24px', borderRadius: '12px', background: '#10b981', color: 'white', border: 'none', fontWeight: '600' },
    cancelButton: { padding: '12px 24px', borderRadius: '12px', background: '#e2e8f0', color: '#4a5568', border: 'none' },
    iconButtonSmall: { background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', padding: '4px' },
    modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 },

    paginationContainer: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: "6px",
        marginTop: "16px",
        paddingTop: "12px",
        borderTop: "1px solid #e5e7eb"
    },

    paginationButton: {
        minWidth: "32px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "8px",
        border: "1px solid #e5e7eb",
        background: "#ffffff",
        color: "#374151",
        fontSize: "13px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.2s ease"
    },

    paginationButtonActive: {
        background: "#3f88a5",
        color: "#ffffff",
        borderColor: "#3f88a5",
        fontWeight: 600
    },

    paginationButtonDisabled: {
        opacity: 0.4,
        cursor: "not-allowed"
    }

};


export const AXIS_FIELD_LABEL_MAP = {
    module: "Module",
    category: "Category",
    sub_category: "Sub Category",
    kpi: "KPI",
    location_id: "Location",
    sublocation_id: "Sub Location",
    displayPeriods: "Period",
    financial_year: "Financial Year",
    meter_id: "Meter"
};

export const buildMeterMap = (graphFilters) => {
    const map = {};
    if (!graphFilters) return map;

    Object.values(graphFilters).forEach(module => {
        if (typeof module !== 'object') return;

        Object.values(module).forEach(category => {
            Object.values(category || {}).forEach(subCategory => {
                Object.values(subCategory || {}).forEach(kpiBlock => {
                    if (Array.isArray(kpiBlock)) {
                        kpiBlock.forEach(meter => {
                            if (meter?.meterId && meter?.meterName) {
                                map[meter.meterId] = meter.meterName;
                            }
                        });
                    }
                });
            });
        });
    });

    return map;
};

export const COLUMN_LABELS = [
    { rawLabel: "module", replaceLabel: "Module" },
    { rawLabel: "category", replaceLabel: "Category" },
    { rawLabel: "sub_category", replaceLabel: "Sub Category" },
    { rawLabel: "kpi", replaceLabel: "KPI" },
    { rawLabel: "location_id", replaceLabel: "Location" },
    { rawLabel: "displayPeriods", replaceLabel: "Period" },
    { rawLabel: "financial_year", replaceLabel: "Financial Year" },
    { rawLabel: "sum_value", replaceLabel: "Value" },
    { rawLabel: "meter_id", replaceLabel: "Meter " }
];

export function capitalizeWords(str) {
  if (!str || typeof str !== "string") return "";

  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const customSelectStyles = {
    control: (provided, state) => ({
        ...provided,
        borderColor: state.isFocused ? '#3f88a5' : '#d1d5db',
        boxShadow: state.isFocused ? '0 0 0 1px #3f88a5' : 'none',
        '&:hover': {
            borderColor: '#3f88a5'
        }
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f2fe'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#0c4a6e'
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#0c4a6e',
        '&:hover': {
            backgroundColor: '#bae6fd',
            color: '#0c4a6e'
        }
    })
};

export const getCustomSelectStyles = (hasError) => ({
    control: (provided, state) => ({
        ...provided,
        borderColor: hasError ? '#dc2626' : (state.isFocused ? '#3f88a5' : '#d1d5db'),
        boxShadow: state.isFocused ? `0 0 0 1px ${hasError ? '#dc2626' : '#3f88a5'}` : 'none',
        '&:hover': {
            borderColor: hasError ? '#dc2626' : '#3f88a5'
        }
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f2fe'
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#0c4a6e'
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#0c4a6e',
        '&:hover': {
            backgroundColor: '#bae6fd',
            color: '#0c4a6e'
        }
    })
});

export const getPeriodsForFinancialYears = (selectedFinancialYears, graphFilters) => {
    if (!selectedFinancialYears || selectedFinancialYears.length === 0 || !graphFilters) {
        return [];
    }
    const financialYearsData = graphFilters['Financial Years'] || {};

    if (selectedFinancialYears.length === 1) {
        const fyValue = selectedFinancialYears[0].value || selectedFinancialYears[0];
        const periodsArray = financialYearsData[fyValue];
        if (periodsArray && Array.isArray(periodsArray)) {
            const uniquePeriods = [];
            const seenValues = new Set();
            periodsArray.forEach(period => {
                if (period && period.value && !seenValues.has(period.value)) {
                    uniquePeriods.push(period);
                    seenValues.add(period.value);
                }
            });
            return uniquePeriods;
        }
        return [];
    }

    let fyWithMinPeriods = null;
    let minPeriodCount = Infinity;

    selectedFinancialYears.forEach(fy => {
        const fyValue = fy.value || fy;
        const periodsArray = financialYearsData[fyValue];

        if (periodsArray && Array.isArray(periodsArray)) {
            const periodCount = periodsArray.length;

            if (periodCount > 0 && periodCount < minPeriodCount) {
                minPeriodCount = periodCount;
                fyWithMinPeriods = fyValue;
            }
        }
    });

    if (fyWithMinPeriods && financialYearsData[fyWithMinPeriods]) {
        const periodsArray = financialYearsData[fyWithMinPeriods];
        const uniquePeriods = [];
        const seenValues = new Set();

        periodsArray.forEach(period => {
            if (period && period.value && !seenValues.has(period.value)) {
                uniquePeriods.push(period);
                seenValues.add(period.value);
            }
        });

        return uniquePeriods;
    }

    return [];
};

export const cardBackgroundStyle = {
    background: "linear-gradient(135deg, #fafafa, #f7f9fc)",
    borderRadius: "16px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 4px 18px rgba(0,0,0,0.07)",
};

export const RepresentationType = {
    Tabular: 'Tabular',
    Summary: 'Summary',
    Graph: 'Graph',
};

export const AggreGatePeriodOption = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days',
    Weeks: 'weeks',
    Months: 'months',
};

export const RepresentationTypeList = createListFromObject(RepresentationType);
export const AggreGatePeriodList = createListFromObject(AggreGatePeriodOption);


export const getSubLocationsForLocations = (selectedLocations, allLocations) => {
    if (!allLocations || !Array.isArray(allLocations)) {
        return [];
    }

    const subLocationsSet = new Set();
    const subLocationsList = [];

    // If no locations are selected, treat it as ALL locations selected
    const locationsToProcess = selectedLocations && selectedLocations.length > 0
        ? selectedLocations
        : allLocations;

    locationsToProcess.forEach(selectedLoc => {
        // Handle both cases: when it's already a full location object or just a selection
        const locationValue = selectedLoc.value || selectedLoc;
        const locationData = selectedLoc.subLocations
            ? selectedLoc
            : allLocations.find(loc => loc.value === locationValue);

        if (locationData && locationData.subLocations && Array.isArray(locationData.subLocations)) {
            locationData.subLocations.forEach(subLoc => {
                if (subLoc && subLoc.value && !subLocationsSet.has(subLoc.value)) {
                    subLocationsList.push(subLoc);
                    subLocationsSet.add(subLoc.value);
                }
            });
        }
    });

    return subLocationsList;
};

export const getDomainCountForGroupField = ({
    groupField,
    filterOptions,
    selectedModules,
}) => {
    const graphFilters = filterOptions.graphFilters;

    if (!graphFilters) return 0;


    if (groupField === 'category') {
        const categories = new Set();

        selectedModules.forEach(module => {
            const moduleData = graphFilters[module];
            if (!moduleData) return;

            Object.keys(moduleData).forEach(cat => categories.add(cat));
        });

        return categories.size;
    }


    if (groupField === 'sub_category') {
        const subCategories = new Set();

        selectedModules.forEach(module => {
            const moduleData = graphFilters[module];
            if (!moduleData) return;

            Object.values(moduleData).forEach(categoryObj => {
                Object.keys(categoryObj).forEach(subCat =>
                    subCategories.add(subCat)
                );
            });
        });

        return subCategories.size;
    }


    if (groupField === 'kpi') {
        const kpis = new Set();

        selectedModules.forEach(module => {
            const moduleData = graphFilters[module];
            if (!moduleData) return;

            Object.values(moduleData).forEach(categoryObj => {
                Object.values(categoryObj).forEach(kpiArray => {
                    kpiArray.forEach(kpi => kpis.add(kpi));
                });
            });
        });

        return kpis.size;
    }


    if (groupField === 'financial_year') {
        return Object.keys(graphFilters['Financial Years'] || {}).length;
    }


    if (groupField === 'location_id') {
        return (filterOptions.locations || []).length;
    }

    return 0;
};

export function normalizeGraph(graph) {
    const rep =
        graph.visualization?.representationType ??
        graph.representationType;

    return {
        ...graph,
        visualization: {
            ...(graph.visualization || {}),
            representationType: rep
        }
    };
}


export const GraphSkeleton = () => (
    <div
        style={{
            width: "100%",
            height: "120px",
            borderRadius: "12px",
            background: "linear-gradient(90deg, #f1f5f9 25%, #e5e7eb 37%, #f1f5f9 63%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.4s ease infinite",
        }}
    >
        <div style={{ padding: "16px" }}>
            <div style={{ height: "14px", width: "40%", background: "#e5e7eb", borderRadius: "6px", marginBottom: "12px" }} />
            <div style={{ height: "12px", width: "60%", background: "#e5e7eb", borderRadius: "6px" }} />
        </div>
    </div>
);

export const PageSkeleton = () => (
    <div
        style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
            gap: "20px",
            padding: "40px",
        }}
    >
        {Array.from({ length: 6 }).map((_, i) => (
            <div
                key={i}
                style={{
                    height: "420px",
                    borderRadius: "16px",
                    background: "linear-gradient(90deg, #f1f5f9 25%, #e5e7eb 37%, #f1f5f9 63%)",
                    backgroundSize: "400% 100%",
                    animation: "shimmer 1.4s ease infinite",
                }}
            />
        ))}
    </div>
);

export const emptyStateStyles = {
    container: {
        textAlign: 'center',
        padding: '60px 20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff',
        borderRadius: '20px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
        margin: '20px 0'
    },
    iconCircle: {
        width: '100px',
        height: '100px',
        background: '#eff6ff',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px'
    },
    title: {
        color: '#1e293b',
        fontWeight: '600',
        fontSize: '24px',
        marginBottom: '12px'
    },
    text: {
        color: '#64748b',
        fontSize: '16px',
        maxWidth: '450px',
        lineHeight: '1.6'
    }
};

export const tableStyles = {
    // Container uses flex to push footer to bottom if modal is tall
    container: {
        display: "flex",
        flexDirection: "column",
        background: "var(--neutralColor)",
        borderRadius: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "1px solid #e2e8f0",
        maxHeight: "70vh", // Prevents modal overflow
        width: "100%",
        overflow: "hidden"
    },
    contextHeader: {
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        padding: "12px 16px",
        background: "var(--neutralColorOpacity)",
        borderBottom: "1px solid #e2e8f0",
        flexShrink: 0
    },
    badge: {
        background: "var(--neutralColor)",
        border: "1px solid #cbd5e1",
        padding: "4px 10px",
        borderRadius: "4px",
        fontSize: "12px",
        color: "var(--tertiaryColor)",
        display: "flex",
        gap: "4px"
    },
    scrollArea: {
        overflow: "auto", // Allows table to scroll while header/footer stay put
        flexGrow: 1
    },
    table: {
        width: "100%",
        borderCollapse: "separate",
        borderSpacing: 0
    },
    th: {
        position: "sticky",
        top: 0,
        zIndex: 10,
        background: "linear-gradient(180deg, #4a97b5, #3f88a5)",
        color: "#ffffff",
        fontWeight: "600",
        fontSize: "13px",
        padding: "14px 16px",
        cursor: "pointer",
        textAlign: "left",
        whiteSpace: "nowrap",
        boxShadow: "inset 0 -1px 0 rgba(255,255,255,0.15)"
    },

    td: {
        padding: "14px 16px",
        borderBottom: "1px solid #e8eef5",
        color: "var(--tertiaryColor)",
        fontSize: "13px",
        lineHeight: 1.4
    },
    footer: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between", // Better use of space in footer
        padding: "12px 16px",
        background: "#fff",
        borderTop: "1px solid #e2e8f0",
        flexShrink: 0
    },
    pageInfo: {
        fontSize: "13px",
        color: "#64748b"
    },
    paginationGroup: {
        display: "flex",
        gap: "4px"
    },
    pageBtn: {
        padding: "5px 10px",
        borderRadius: "4px",
        border: "1px solid #e2e8f0",
        background: "#fff",
        fontSize: "12px",
        cursor: "pointer",
        transition: "all 0.2s"
    },
    activePage: {
        background: "#3f88a5",
        color: "#fff",
        borderColor: "#3f88a5"
    }
};
